import { getCustomerPayments, getOrderById, physicalPayment } from 'api/payment';
import { validateDiscount, getActiveDiscount } from 'api/customer/discount';
import { validateCustomerPayment,  } from 'api/customer/payment';
import { useSnackbar } from 'notistack';
import { useMutation, useQuery } from 'react-query';

function usePayment(success, error) {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(physicalPayment, {
    onError: (err) => {
      enqueueSnackbar(err.message, { variant: 'error' });
      error && error(err);
    },
    onSuccess: () => {
      enqueueSnackbar('پرداخت با موفقیت ثبت شد.', { variant: 'success' });
      success();
    },
  });
}

function useValidatePayment() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(validateCustomerPayment, {
    onError: (err) => {
      // enqueueSnackbar(err.message, { variant: 'error' })
      // error && error(err);
    },
    onSuccess: () => {
      // enqueueSnackbar('پرداخت با موفقیت ثبت شد.', { variant: 'success' })
      // success();
    },
  });
}

function useActiveDiscount(){
  return useMutation(getActiveDiscount);
}

function useValidateDiscount() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(validateDiscount, {
    onError: (err) => {
      console.log("err",err)
      enqueueSnackbar(err.message, { variant: 'error' });
      // error && error(err);
    },
    onSuccess: (data) => {
      if(data.status ==="OK")
      enqueueSnackbar('تخفیف  با موفقیت اعمال شد', { variant: 'success' });
      else
      enqueueSnackbar(data.message, { variant: 'error' });
      // success();
    },
  });
}

function useCustomerPayments(id) {
  return useQuery(['customerPayments', id], () => getCustomerPayments(id), {
    enabled: !!id,
  });
}

function useOrder(id) {
  return useQuery(['order', id], () => getOrderById(id), {
    enabled: !!id,
  });
}

export { usePayment, useValidatePayment, useCustomerPayments, useOrder, useValidateDiscount, useActiveDiscount };
